import axios from 'axios';
import logger from '../utils/logger';

const API_URL = import.meta.env.REACT_APP_API_URL || 'https://api.spark.rapidlearningcycles.com';

// Create axios instance with auth header
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {};
};

// Feedback API service
const feedbackService = {
  // Submit feedback
  submitFeedback: async (feedbackData) => {
    try {
      const response = await axios.post(
        `${API_URL}/feedback/submit`,
        feedbackData,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error submitting feedback:', error);
      throw error;
    }
  },

  // Get all feedback (admin only)
  getFeedbackList: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.statusFilter) params.append('status_filter', filters.statusFilter);
      if (filters.featureFilter) params.append('feature_filter', filters.featureFilter);
      if (filters.ratingFilter) params.append('rating_filter', filters.ratingFilter);
      if (filters.tenantIdFilter) params.append('tenant_id_filter', filters.tenantIdFilter);
      if (filters.sortBy) params.append('sort_by', filters.sortBy);
      if (filters.sortOrder) params.append('sort_order', filters.sortOrder);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.offset) params.append('offset', filters.offset);

      const response = await axios.get(
        `${API_URL}/admin/feedback/list?${params.toString()}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error fetching feedback list:', error);
      throw error;
    }
  },

  // Mark feedback as read (admin only)
  markAsRead: async (tenantId, feedbackId) => {
    try {
      const response = await axios.post(
        `${API_URL}/admin/feedback/mark-read`,
        { tenant_id: tenantId, feedback_id: feedbackId },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error marking feedback as read:', error);
      throw error;
    }
  },

  // Mark feedback as unread (admin only)
  markAsUnread: async (tenantId, feedbackId) => {
    try {
      const response = await axios.post(
        `${API_URL}/admin/feedback/mark-unread`,
        { tenant_id: tenantId, feedback_id: feedbackId },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error marking feedback as unread:', error);
      throw error;
    }
  }
};

export default feedbackService;